import React from "react";
import { gql, useQuery } from "@apollo/client";
import { Link } from "react-router-dom";
import { LegacyCard, SkeletonBodyText } from "@shopify/polaris";
import { useTranslation } from "react-i18next";
import { PricesToolTips } from "src/screens/applications/products/item/upload/PricesToolTips";

const QUERY_SUPPLIER_INVENTORY_STATUS = gql`
  query supplierInventoryStatus {
    supplierInventoryStatus {
      supplierFee {
        storageFee
        fblRemovalFee
        fblProcessingFee
      }
      unpaidInventoryFee
      unpaidProcessingFee
      unpaidProcessingUnits
      unpaidRemovalFee
      unpaidRemovalUnits
      totalStock
      fblProduct
      totalVolumes
      stockRetailPrice
    }
  }
`;

type distype = "Inventory fees rate" | "Unpaid fees" | "Inventory status";

interface props {
  display: {
    value: distype;
    link: string;
  }[];
}

export function InventoryStatus({ display }: props) {
  const { t } = useTranslation();
  const { data, loading, error } = useQuery(QUERY_SUPPLIER_INVENTORY_STATUS, {
    fetchPolicy: "no-cache",
  });

  if (error || loading || !data) {
    return (
      <>
        <LegacyCard.Section>
          <SkeletonBodyText />
        </LegacyCard.Section>
        <LegacyCard.Section>
          <SkeletonBodyText />
        </LegacyCard.Section>
        <LegacyCard.Section>
          <SkeletonBodyText />
        </LegacyCard.Section>
      </>
    );
  }

  const items: any = {
    "Inventory fees rate": {
      "Inventory Storage fee": data.supplierInventoryStatus.supplierFee.storageFee,
      "FBL Inventory processing fee": data.supplierInventoryStatus.supplierFee.fblProcessingFee,
      "FBL Inventory Removal fee": data.supplierInventoryStatus.supplierFee.fblRemovalFee,
      footer: ["If there are changes, we will inform in advance."],
    },
    "Unpaid fees": {
      [t("page_dashboard.unpaid_fees.inventory_storage_fee")]: `$${data.supplierInventoryStatus.unpaidInventoryFee}`,
      [t(
        "page_dashboard.unpaid_fees.fbl_inventory_processing_fee",
      )]: `$${data.supplierInventoryStatus.unpaidProcessingFee} (${data.supplierInventoryStatus.unpaidProcessingUnits} units)`,
      [t(
        "page_dashboard.unpaid_fees.fbl_inventory_removal_fee",
      )]: `$${data.supplierInventoryStatus.unpaidRemovalFee} (${data.supplierInventoryStatus.unpaidRemovalUnits} units)`,
      footer: [[t("page_dashboard.unpaid_fees.footer")]],
    },
    "Inventory status": {
      [t("page_dashboard.inventory_status.total_stock")]: `${data.supplierInventoryStatus.totalStock} units`,
      [t("page_dashboard.inventory_status.fbl_product")]: data.supplierInventoryStatus.fblProduct,
      [t("page_dashboard.inventory_status.current_volumnes")]: `${Number(
        data.supplierInventoryStatus.totalVolumes ?? 0,
      ).toFixed(2)} CBM`,
      [t("page_dashboard.inventory_status.current_stock_retail_value")]: `$${Number(
        data.supplierInventoryStatus.stockRetailPrice ?? 0,
      ).toFixed(2)}`,
      footer: [[t("page_dashboard.inventory_status.footer.0")], [t("page_dashboard.inventory_status.footer.1")]],
    },
  };

  const title = {
    "Unpaid fees": t("page_dashboard.unpaid_fees.title"),
    "Inventory status": t("page_dashboard.inventory_status.title"),
  };

  //@ts-ignore
  return (
    <>
      {Object.keys(items).map((obj, i) => {
        const index = display.findIndex((f) => f.value === obj);
        if (index >= 0) {
          return (
            <LegacyCard.Section key={i}>
              {/* to={display[index].link}
              className="post-box"
              style={{
                backgroundColor: i === 0 ? "#DD948E" : i === 1 ? "#f1cebb" : "#a1c6c2",
                textDecoration: "none",
                color: "#000",
              }}
              key={i} */}
              <Link
                to={display[index].link}
                className="post-box"
                style={{
                  backgroundColor: i === 0 ? "#DD948E" : i === 1 ? "#f1cebb" : "#a1c6c2",
                  textDecoration: "none",
                  color: "#000",
                }}
              >
                <div className="p-2">
                  <h6 className="post-title">{(title as any)[obj]}</h6>
                  <div className="post-footer">
                    <ol style={{ padding: 13, margin: 0 }}>
                      {Object.keys(items[obj] as any).map((x, j) => {
                        if (x !== "footer") {
                          let title = <span>{x}</span>;
                          if (x === t("page_dashboard.inventory_status.current_stock_retail_value")) {
                            title = (
                              <PricesToolTips>
                                {x} <b>(?)</b>
                              </PricesToolTips>
                            );
                          }

                          return (
                            <li
                              style={{
                                paddingTop: 5,
                                paddingBottom: 5,
                              }}
                              key={j}
                            >
                              {title}: {j === 0 ? ((items[obj][x] + "") as string).toUpperCase() : items[obj][x]}
                            </li>
                          );
                        }
                        return <></>;
                      })}
                    </ol>
                  </div>
                  <div className="post-text">
                    {items[obj].footer.map((str: any) => {
                      return (
                        <div key={str}>
                          <small>{str}</small>
                          <br />
                        </div>
                      );
                    })}
                  </div>
                </div>
              </Link>
            </LegacyCard.Section>
          );
        }
        return null;
      })}
    </>
  );
}
